import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toWords } from "number-to-words";
import { getDecodedToken } from "../auth";
import { useState } from "react";

const FeeReceipt = (receiptData, student) => {
  if (!receiptData || !Array.isArray(receiptData) || receiptData.length === 0) {
    alert("No data available to export.");
    return;
  }

  const user = getDecodedToken();

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  doc.setFontSize(8); // Smaller font for compact layout

  const renderReceipt = (data, student, startX, startY, copyTitle) => {
    const feeDetails = data.feeDetails;
    let totalAmount = 0;
    let rowIndex = 1;
    let paymentModes = {};
    const tableData = [];

    const addFeeRow = (description, amount) => {
      if (amount > 0) {
        tableData.push([rowIndex++, description, amount.toFixed(2)]);
        totalAmount += amount;
      }
    };

    addFeeRow("Admission Fee", feeDetails.admissionFee?.TotalAmt || 0);
    addFeeRow("Development Fee", feeDetails.developmentCharges?.TotalAmt || 0);

    let monthlyFeeTotal = 0;
    let transportFeeTotal = 0;
    let labFeeTotal = 0;
    let monthlyFeeMonths = [];

    if (feeDetails.monthPaid && Array.isArray(feeDetails.monthPaid)) {
      feeDetails.monthPaid.forEach((month) => {
        if (month.paid) {
          monthlyFeeMonths.push(month.month);
          monthlyFeeTotal += month.monthlyFee || 0;
          transportFeeTotal += month.transportFee || 0;
          labFeeTotal += month.labFee || 0;
        }

        if (month.paid && month.paymentMode) {
          Object.entries(month.paymentMode).forEach(([mode, details]) => {
            paymentModes[mode] = (paymentModes[mode] || 0) + details.amount;
          });
        }
      });
    }

    addFeeRow("Monthly Fee", monthlyFeeTotal);
    addFeeRow("Transport Fee", transportFeeTotal);
    addFeeRow("Lab Fee", labFeeTotal);

    ["admissionFee", "developmentCharges"].forEach((feeType) => {
      if (feeDetails[feeType]?.paid && feeDetails[feeType].paymentMode) {
        Object.entries(feeDetails[feeType].paymentMode).forEach(
          ([mode, details]) => {
            paymentModes[mode] = (paymentModes[mode] || 0) + details.amount;
          },
        );
      }
    });

    tableData.push(["", "Total Amount", totalAmount.toFixed(2)]);

    const schoolLogo = "/assets/images/icon.png";
    const pageWidth = doc.internal.pageSize.getWidth();
    const receiptWidth = pageWidth / 2;
    const textX = startX + receiptWidth / 2;
    const textY = startY + 10;

    const centerX = startX + receiptWidth / 2;
    const logoWidth = 15;
    const logoHeight = 15;
    const logoX = centerX - logoWidth / 2;
    const logoY = startY - 5;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.text(copyTitle, startX + 10, 5);
    doc.addImage(schoolLogo, "PNG", logoX + 2, logoY, logoWidth, logoHeight);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Acharyakulam", centerX + 2, startY + 15, { align: "center" });
    doc.setFontSize(7);
    doc.text(
      `SESSION ${user?.currentSession || ""}`,
      centerX + 2,
      startY + 18,
      {
        align: "center",
      },
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    doc.text(
      "Near Namkum Police Station, Tata Road, Namkum, Ranchi - 834010",
      centerX + 2,
      startY + 22,
      { align: "center" },
    );
    doc.text(
      "6287842461, 6287842463, 06512950555",
      centerX + 2,
      startY + 28.5,
      {
        align: "center",
      },
    );
    doc.text("www.acharyakulamranchi.com", centerX + 2, startY + 25, {
      align: "center",
    });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("FEE RECEIPT", centerX + 2, startY + 33, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    const studentInfo = `Student's Name : ${student?.name}\nFather's Name : ${
      student?.parentDetails[0]?.name || "N/A"
    }\nPhone No : ${
      student?.studentDetails?.phoneNo || "N/A"
    }\nClass & Section : ${data.class}, ${
      data.currentSection
    }\nFee For (Months) : ${monthlyFeeMonths.join(", ")}`;

    const stoppage = student?.transportFacility?.busStop
      ? `Stoppage : ${student.transportFacility.busStop.replace(
          /\b\w/g,
          (char) => char.toUpperCase(),
        )}`
      : "";

    const busNo = student?.transportFacility?.busNumber
      ? `Bus No : ${student.transportFacility.busNumber.replace(
          /\b\w/g,
          (char) => char.toUpperCase(),
        )}`
      : "";

    const receiptInfo = `Receipt No : ${data.receipt_no}\nDate : ${
      data.date ? new Date(data.date).toLocaleDateString() : "N/A"
    }\nAdmission No : ${data.admission_no}\n${stoppage ? stoppage + "\n" : ""}${
      busNo ? busNo : ""
    }`;

    autoTable(doc, {
      startY: startY + 38,
      body: [
        [
          {
            content: studentInfo,
            styles: {
              fontSize: 7,
              cellPadding: 2,
              halign: "left",
              valign: "top",
              textColor: 0,
            },
          },
          {
            content: receiptInfo,
            styles: {
              fontSize: 7,
              cellPadding: 2,
              halign: "right",
              valign: "top",
              textColor: 0,
            },
          },
        ],
      ],
      theme: "grid",
      styles: { fontSize: 5, cellPadding: 1, lineColor: 0, lineWidth: 0.1 },
      columnStyles: { 0: { cellWidth: 45 }, 1: { cellWidth: 45 } },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 2,
      head: [["#", "Fee Head (Description)", "Amount"]],
      body: tableData,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: 0,
        lineWidth: 0.1,
        textColor: 0,
      },
      headStyles: {
        fontSize: 7,
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 55 },
        2: { cellWidth: 25 },
      },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    const capitalizeWords = (str) =>
      str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    const amountInWords = `${capitalizeWords(toWords(totalAmount))} Only`;

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 2,
      head: [["Total Amount (In Words)"]],
      body: [[amountInWords]],
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: 0,
        lineWidth: 0.1,
        textColor: 0,
      },
      headStyles: {
        fontSize: 7,
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.1,
      },
      columnStyles: { 0: { cellWidth: 90 } },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    const paymentModeData = Object.entries(paymentModes).map(
      ([mode, amount]) => [mode, amount.toFixed(2)],
    );
    if (paymentModeData.length > 0) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 2,
        head: [["Mode of Payment", "Amount"]],
        body: paymentModeData,
        theme: "grid",
        styles: {
          fontSize: 7,
          cellPadding: 1,
          lineColor: 0,
          lineWidth: 0.1,
          textColor: 0,
        },
        headStyles: {
          fontSize: 7,
          fillColor: [255, 255, 255],
          textColor: 0,
          lineColor: 0,
          lineWidth: 0.1,
        },
        columnStyles: { 0: { cellWidth: 55 }, 1: { cellWidth: 35 } },
        tableWidth: receiptWidth - 20,
        margin: { left: startX + 10 },
      });
    }

    doc.setFontSize(7);
    doc.text(
      "Authorized Signature",
      startX + 70,
      doc.lastAutoTable.finalY + 15,
    );
  };

  let startY = 10;
  const receiptHeight = 140;

  receiptData.forEach((data) => {
    renderReceipt(data, student, 0, startY, "Office Copy");
    renderReceipt(data, student, 100, startY, "Parent's Copy");
    startY += receiptHeight;
  });

  window.open(doc.output("bloburl"), "_blank");
};

export default FeeReceipt;
